import React from "react";
import ReactDOM from "react-dom/client"; // Correct React 18 import
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import ChatProvider from "./Context/ChatProvider";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import { requestForToken, onMessageListener } from "./firebase";
import axios from "./axiosConfig";

// Register FCM token
requestForToken()
  .then((token) => {
    if (token) {
      console.log("✅ FCM Token:", token);
      const userInfo = JSON.parse(localStorage.getItem("userInfo"));
      if (userInfo?.token) {
        axios
          .post(
            "/api/user/fcm-token",
            { token },
            {
              headers: { Authorization: `Bearer ${userInfo.token}` },
            }
          )
          .then(() => console.log("FCM token registered with backend"))
          .catch((err) => console.error("❌ Failed to save FCM token:", err));
      }
    } else {
      console.warn("🔇 Notification permission not granted");
    }
  })
  .catch((err) => {
    console.error("❌ FCM token error:", err);
  });

// Handle FCM foreground messages
onMessageListener()
  .then((payload) => {
    const { title, body } = payload.notification;
    if (Notification.permission === "granted") {
      new Notification(title, { body });
    }
  })
  .catch((err) => {
    console.error("❌ onMessageListener error:", err);
  });

// React 18 render method
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ChakraProvider>
    {/* Add the future prop to BrowserRouter for React Router v7 warnings */}
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <ChatProvider>
        <App />
      </ChatProvider>
    </BrowserRouter>
  </ChakraProvider>
);

reportWebVitals();
